
/* =====================================
   MINTA MAISON - COUNTDOWN 2.1
   Timer con scadenza reale
===================================== */

(function () {
  if (customElements.get('minta-countdown')) return;

  class MintaCountdown extends HTMLElement {
    connectedCallback() {
      const endAt = this.getAttribute('end-at');
      this.deadline = Date.parse(endAt || '');
      this.output = this.querySelector(
        '[data-countdown-output]'
      );

      if (!Number.isFinite(this.deadline) || !this.output) {
        this.hidden = true;
        return;
      }

      this.updateClock();

      if (!this.hidden && !this.interval) {
        this.interval = setInterval(
          () => this.updateClock(),
          1000
        );
      }
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.interval = null;
    }

    updateClock() {
      const remaining = Math.max(
        0,
        Math.ceil((this.deadline - Date.now()) / 1000)
      );

      if (remaining <= 0) {
        this.hidden = true;

        if (this.interval) {
          clearInterval(this.interval);
        }

        this.interval = null;
        return;
      }

      const days = Math.floor(remaining / 86400);
      const hours = Math.floor(
        (remaining % 86400) / 3600
      );
      const minutes = Math.floor(
        (remaining % 3600) / 60
      );
      const seconds = remaining % 60;

      const pad = n => String(n).padStart(2, '0');

      this.output.textContent =
        (days ? days + 'g ' : '') +
        pad(hours) + ':' +
        pad(minutes) + ':' +
        pad(seconds);
    }
  }

  customElements.define(
    'minta-countdown',
    MintaCountdown
  );
})();